
//import React from 'react';
//import Table from './components/Table';

import React, { Component } from "react";
import { render } from "react-dom";

import moment from 'moment';

import API from './API';
import './App.css';

class EventListing extends Component {
  constructor(props) {
    super(props);

    this.api = new API();
    this.idleTimeout = 30 * 60 * 1000;
	
    this.state = {
		events: []
    };

}

componentDidMount() {
	let theApp = this;
	
	this.api.getevents(function done(data) {
	  if (data) {
		  console.log(data);
		  theApp.setState(
			theApp.state.events = data
			)
	  }
	}, function notFound() {
	  // not found
		console.log('not found');
	}, function fail(xhr) {
	  console.log(xhr);
	  //onFail();
	});
}

render() {
  return(
    <div className="EventListing">
		<h1>Events</h1>
<table class="table">
  <thead class="thead-dark">
    <tr>
      <th scope="col">Event name</th>
      <th scope="col">Date</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
  {this.getEventsData()}
  </tbody>
</table>
    </div>
  );	
}


getEventsData = function(){
        return this.state.events.map(anevent => {
            return (
			
    <tr>
      <th scope="row">{anevent.name}</th>
      <th scope="row">{moment(anevent.event_date).format('DD/MM/YYYY')}</th>
      <td><a href={"/?event_id="+anevent.id}>View results</a></td>
    </tr>

            );
        })

}

}


  
export default EventListing;
